import { useState, useContext, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { IBilling } from 'domain/entities/Billing/Billing';
import { BuyerBillingQuery } from 'interfaceAdapter/queries/BuyerBilling';

export const useBilling = () => {
    const diContainer = useContext(diContainerContext);
    const buyerBillingQuery = diContainer.resolve(BuyerBillingQuery);
    const [billingList, setBillingList] = useState<IBilling[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await buyerBillingQuery.fetchList();
            setBillingList(data);
        };
        fetchData();
    }, []);

    return { billingList };
};
